import axios from '@/api/axios-fortune-telling.js'
import axiosUser from '@/api/axios-users.js'
import godData from '@/constants/fortune-telling/10-gods.js'
import parseTenGod from '@/constants/fortune-telling/ten-god-abbr'
import deepmerge from 'deepmerge'
import {
  getYearBranch,
  getMonthBranch,
  getDayMonthAuxilaryStar,
  getDayStem,
  getDayBranch,
  getYearBranchDestiny,
  getMonthBranchDestiny,
  getDayMonthAuxilaryStarDestiny,
  getDayStemDestiny,
  getDayBranchDestiny,
} from '@/constants/fortune-telling/calculation.js'

const state = {
  auspiciousColor: {},
  luckPillar: [],
  monthlyInfluence: [],
  annualBazi: {
    hourBranch: [],
    dayBranch: [],
    monthBranch: [],
    yearBranch: [],
  },
  myDestiny: {
    hourBranch: [],
    dayBranch: [],
    monthBranch: [],
    yearBranch: [],
  },
  currentDate: null,
  currentChineseDate: null,
  tenGod: [],
  bazi: {},
  fiveStructure: [],
  userData: [],
  currentYear: {},
  searchHistory: [],
  // userDateOfBirth: null,
  // userTimeOfBirthh: null,
  fortune: null,
}

const getters = {
  bazi(state) {
    return state.bazi
  },
  luckPillar(state) {
    return state.luckPillar
  },
  fiveStructure(state) {
    return state.fiveStructure
  },
  tenGod(state) {
    return state.tenGod
  },
  annualBazi(state) {
    return state.annualBazi
  },
  myDestiny(state) {
    return state.myDestiny
  },
  monthlyInfluence(state) {
    return state.monthlyInfluence
  },
  userData(state) {
    return state.userData
  },
  searchHistory(state) {
    return state.searchHistory
  },
  userDailyColor(state) {
    return state.auspiciousColor
  },
  currentYear(state) {
    return state.currentYear
  },
  currentDate(state) {
    return state.currentDate
  },
  currentChineseDate(state) {
    return state.currentChineseDate
  },
  fortune(state) {
    return state.fortune
  },
}

const mutations = {
  addSearchDate(state, date) {
    state.searchHistory.push(date)
  },
  setMyDestiny(state, data) {
    state.myDestiny = data
  },
  setAnnualBazi(state, data) {
    state.annualBazi = data
  },
  clearAnnualBazi(state) {
    state.annualBazi.hourBranch = []
    state.annualBazi.dayBranch = []
    state.annualBazi.monthBranch = []
    state.annualBazi.yearBranch = []
  },

  clearMyDestiny(state) {
    state.myDestiny.hourBranch = []
    state.myDestiny.dayBranch = []
    state.myDestiny.monthBranch = []
    state.myDestiny.yearBranch = []
  },
  setUserAuspiciousColor(state, data) {
    state.auspiciousColor = data
  },
  setUserDateOfBirth(state, data) {
    state.userDateOfBirth = data
  },
  setUserTimeOfBirth(state, data) {
    state.userTimeOfBirthh = data
  },
  setBazi(state, data) {
    state.bazi = data
  },
  setLuckPillar(state, data) {
    state.luckPillar = data
  },
  setMonthlyInfluence(state, data) {
    state.monthlyInfluence = data
  },
  setFiveStructure(state, data) {
    state.fiveStructure = [...data]
  },
  setTenGod(state, data) {
    state.tenGod = data
  },
  setUserData(state, data) {
    state.userData = data
  },
  clearUserData(state) {
    state.userData = []
  },
  setCurrentYear(state, currentYearNatal) {
    state.currentYear = currentYearNatal
  },
  setCurrentDate(state, date) {
    state.currentDate = date
  },
  setCurrentChineseDate(state, date) {
    state.currentChineseDate = date
  },
  deleteSearchDate(state, index) {
    state.searchHistory.splice(index, 1)
  },
  setFortune(state, data) {
    state.fortune = data
  },
}

const actions = {
  clearUserData: ({ commit }) => {
    commit('clearUserData')
  },
  addUserSearch: ({ commit }, payload) => {
    commit('addSearchDate', payload)
  },
  deleteSearchDate: ({ commit }, index) => {
    commit('deleteSearchDate', index)
  },
  uploadLottery: ({ commit }, payload) => {
    axios
      .post('/lottery', payload.formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        dispatch('setAlertMessage', {
          message: 'อัพโหลดสำเร็จ',
          type: 'success',
        })
      })
      .catch((err) => {
        this.$refs.fileInput.remove()
        dispatch('setAlertMessage', {
          message: 'เกิดข้อผิดพลาด',
          type: 'error',
        })
      })
  },

  fetchFortune: (
    { commit, dispatch },
    { date, time, gender, startYear, endYear, aspect }
  ) => {
    let params = {
      date_of_birth: date,
      time_of_birth: time || 'null',
      gender: gender,
      start_year: startYear,
      end_year: endYear,
      aspect: aspect,
    }

    params = cleanParams(params)

    axios
      .get(`/ai/personal-fortune-demo`, { params: params })
      // .get(`http://localhost:8082/ai/personal-fortune-demo`, { params: params })
      .then((res) => {
        let fortune = res.data

        function reverseTenGod(dayMaster, tenGod) {
          const data = {
            'Yang Wood': {
              F: '甲',
              RW: '乙',
              EG: '丙',
              HO: '丁',
              IW: '戊',
              DW: '己',
              SK: '庚',
              DO: '辛',
              IR: '壬',
              DR: '癸',
            },
            'Yin Wood': {
              RW: '甲',
              F: '乙',
              HO: '丙',
              EG: '丁',
              DW: '戊',
              IW: '己',
              DO: '庚',
              SK: '辛',
              DR: '壬',
              IR: '癸',
            },
            'Yang Fire': {
              IR: '甲',
              DR: '乙',
              F: '丙',
              RW: '丁',
              EG: '戊',
              HO: '己',
              IW: '庚',
              DW: '辛',
              SK: '壬',
              DO: '癸',
            },
            'Yin Fire': {
              DR: '甲',
              IR: '乙',
              RW: '丙',
              F: '丁',
              HO: '戊',
              EG: '己',
              DW: '庚',
              IW: '辛',
              DO: '壬',
              SK: '癸',
            },
            'Yang Earth': {
              SK: '甲',
              DO: '乙',
              IR: '丙',
              DR: '丁',
              F: '戊',
              RW: '己',
              EG: '庚',
              HO: '辛',
              IW: '壬',
              DW: '癸',
            },
            'Yin Earth': {
              DO: '甲',
              SK: '乙',
              DR: '丙',
              IR: '丁',
              RW: '戊',
              F: '己',
              HO: '庚',
              EG: '辛',
              DW: '壬',
              IW: '癸',
            },
            'Yang Metal': {
              IW: '甲',
              DW: '乙',
              SK: '丙',
              DO: '丁',
              IR: '戊',
              DR: '己',
              F: '庚',
              RW: '辛',
              EG: '壬',
              HO: '癸',
            },
            'Yin Metal': {
              DW: '甲',
              IW: '乙',
              DO: '丙',
              SK: '丁',
              DR: '戊',
              IR: '己',
              RW: '庚',
              F: '辛',
              HO: '壬',
              EG: '癸',
            },
            'Yang Water': {
              EG: '甲',
              HO: '乙',
              IW: '丙',
              DW: '丁',
              SK: '戊',
              DO: '己',
              IR: '庚',
              DR: '辛',
              F: '壬',
              RW: '癸',
            },
            'Yin Water': {
              HO: '甲',
              EG: '乙',
              DW: '丙',
              IW: '丁',
              DO: '戊',
              SK: '己',
              DR: '庚',
              IR: '辛',
              RW: '壬',
              F: '癸',
            },
          }
          return data[dayMaster]?.[tenGod]
        }

        let tenGodList = fortune.ten_god_ratio.map((e) => {
          return {
            ...e,
            abbr: parseTenGod[e.ten_god],
          }
        })

        let results = []

        function getReverseTenGod(dayMaster, tenGod) {
          results.push({
            ten_god: tenGod,
            result: reverseTenGod(dayMaster, tenGod),
          })
        }

        if (fortune.bazi.hour) {
          getReverseTenGod(
            fortune.bazi.day.heavenly_stem.element.full_name_en,
            fortune.bazi.hour.heavenly_stem.ten_god.name_en_abbr
          )
          getReverseTenGod(
            fortune.bazi.day.heavenly_stem.element.full_name_en,
            fortune.bazi.hour.earthly_branch.ten_god.name_en_abbr
          )
          fortune.bazi.hour.hidden_stems.forEach((item) => {
            getReverseTenGod(
              fortune.bazi.day.heavenly_stem.element.full_name_en,
              item.ten_god.name_en_abbr
            )
          })
        }
        // getReverseTenGod(fortune.bazi.day.heavenly_stem.element.full_name_en, fortune.bazi.day.heavenly_stem.ten_god.name_en_abbr)
        getReverseTenGod(
          fortune.bazi.day.heavenly_stem.element.full_name_en,
          fortune.bazi.day.earthly_branch.ten_god.name_en_abbr
        )
        fortune.bazi.day.hidden_stems.forEach((item) => {
          getReverseTenGod(
            fortune.bazi.day.heavenly_stem.element.full_name_en,
            item.ten_god.name_en_abbr
          )
        })
        getReverseTenGod(
          fortune.bazi.day.heavenly_stem.element.full_name_en,
          fortune.bazi.month.heavenly_stem.ten_god.name_en_abbr
        )
        getReverseTenGod(
          fortune.bazi.day.heavenly_stem.element.full_name_en,
          fortune.bazi.month.earthly_branch.ten_god.name_en_abbr
        )
        fortune.bazi.month.hidden_stems.forEach((item) => {
          getReverseTenGod(
            fortune.bazi.day.heavenly_stem.element.full_name_en,
            item.ten_god.name_en_abbr
          )
        })
        getReverseTenGod(
          fortune.bazi.day.heavenly_stem.element.full_name_en,
          fortune.bazi.year.heavenly_stem.ten_god.name_en_abbr
        )
        getReverseTenGod(
          fortune.bazi.day.heavenly_stem.element.full_name_en,
          fortune.bazi.year.earthly_branch.ten_god.name_en_abbr
        )
        fortune.bazi.year.hidden_stems.forEach((item) => {
          getReverseTenGod(
            fortune.bazi.day.heavenly_stem.element.full_name_en,
            item.ten_god.name_en_abbr
          )
        })

        // Convert resultData to a map for quick lookup
        const resultMap = results.reduce((acc, { ten_god, result }) => {
          acc[ten_god] = result
          return acc
        }, {})

        // Merge into baseData
        const mergedData = tenGodList.map((item) => ({
          ...item,
          result: resultMap[item.abbr] || '',
        }))

        fortune.ten_god_ratio = mergedData

        let aspects = {
          career: ['Dragon Virtue'],
          finance: ['Golden Chest'],
          relationship: ['Hook'],
          health: ['Blood Blade'],
          study: [],
        }

        fortune.aspects = aspects

        fortune.luck_pillars = fortune.luck_pillars
          .sort((a, b) => b.start_age - a.start_age)
          .map((e) => {
            let { metal, water, wood, fire, earth } = e.five_structure
            const fiveStucture = [metal, water, wood, fire, earth]
            return {
              ...e,
              five_structure: fiveStucture,
              pillar_interactions: Object.entries(e.pillar_interactions).map(
                ([key, value]) => ({ key, value })
              ),
              ten_god_ratio: e.ten_god_ratio.sort((a, b) => b.ratio - a.ratio),
              aspects: aspects,
            }
          })

        fortune.year_pillars = fortune.year_pillars
          .sort((a, b) => b.year - a.year)
          .map((e) => {
            let { metal, water, wood, fire, earth } = e.five_structure
            const fiveStucture = [metal, water, wood, fire, earth]
            let tengod = e.ten_god_ratio
            return {
              ...e,
              aspects: aspects,

              ten_god_ratio: tengod.sort((a, b) => b.ratio - a.ratio),
              five_structure: fiveStucture,
              pillar_interactions: Object.entries(e.pillar_interactions).map(
                ([key, value]) => ({ key, value })
              ),
              monthly_influence: e.monthly_influence.map((item) => {
                let { metal, water, wood, fire, earth } =
                  item.month_pillar.five_structure
                const fiveStucture = [metal, water, wood, fire, earth]
                return {
                  date: item.date,
                  month_pillar: {
                    ...item.month_pillar,
                    pillar_interactions: Object.entries(
                      e.pillar_interactions
                    ).map(([key, value]) => ({ key, value })),
                    five_structure: fiveStucture,
                    ten_god_ratio: item.month_pillar.ten_god_ratio.sort(
                      (a, b) => b.ratio - a.ratio
                    ),
                    aspects: aspects,
                  },
                  aspects: aspects,
                }
              }),
            }
          })

        fortune.ten_god_ratio = fortune.ten_god_ratio.sort(
          (a, b) => b.ratio - a.ratio
        )
        fortune.pillar_interactions = Object.entries(
          fortune.pillar_interactions
        ).map(([key, value]) => ({ key, value }))

        let { metal, water, wood, fire, earth } = fortune.five_structure
        const fiveStucture = [metal, water, wood, fire, earth]
        fortune.five_structure = fiveStucture

        commit('setFortune', fortune)
      })
      .catch((err) => {
        console.log(err)
      })
  },
  fetchDate: ({ commit, dispatch }, request) => {
    request.time = request.time === '' ? 'null' : request.time
    let currentYearNatal = {}
    let birthNatal = {}
    let promises = []
    let date = request.date
    let params = {
      date: date,
      // time: request.time,
    }
    if (request.time !== 'null') {
      params.time = request.time
    }
    promises.push(
      axios
        .get(`/bazis/${request.date}`, { params: params })
        .then((res) => {
          let currentDate = `${date} ${request.time === 'null' ? '' : request.time}`
          commit('setCurrentDate', currentDate)
          commit('setCurrentChineseDate', res.data.chinese_date)
          let natal = res.data
          birthNatal = { ...natal }
          commit('setBazi', natal)
          // dispatch('getTenGod', natal);
          dispatch('getMyDestiny', natal)
        })
        .catch((err) => {
          console.log(err)
        })
    )
    // Fetch current year
    promises.push(
      axios
        .get(`/bazis/${request.date}`, { params: params })
        .then((res) => {
          currentYearNatal = res.data.year
          commit('setCurrentYear', currentYearNatal)
        })
        .catch((err) => {
          console.log(err.message)
        })
    )
    Promise.allSettled(promises).then(() => {
      dispatch('getAnnualBazi', {
        birthNatal: birthNatal,
        currentYearNatal: currentYearNatal,
      })
    })
  },

  fetchUserByID: async ({ commit, dispatch }, id) => {
    await axiosUser
      .get(`/users/${id}`)
      .then((res) => {
        // Check if user is found
        let user = res.data
        if (user.date_of_birth) {
          dispatch('fetchDate', {
            date: user.date_of_birth,
            time: user.time_of_birth === '' ? 'null' : user.time_of_birth,
          })
          dispatch('fetchLuckPillar', {
            date: user.date_of_birth,
            gender: user.gender,
          })
          commit('addSearchDate', {
            name: user.full_name,
            date: user.date_of_birth,
            time: user.time_of_birth,
            gender: user.gender,
          })
          commit('setUserData', user)
        } else {
          dispatch('setAlertMessage', {
            message: 'ไม่พบ user',
            type: 'error',
          })
        }
      })
      .catch((err) => {})
  },

  fetchLuckPillar: async ({ commit }, request) => {
    await axios
      .get(`/luck-pillar/${request.date}`, {
        params: {
          gender: request.gender,
        },
      })
      .then((res) => {
        let reArrange = {
          1: res.data[0],
          10: res.data[1],
          20: res.data[2],
          30: res.data[3],
          40: res.data[4],
          50: res.data[5],
          60: res.data[6],
          70: res.data[7],
          80: res.data[8],
        }
        console.log(JSON.parse(JSON.stringify(reArrange)))
        commit('setLuckPillar', reArrange)
      })
      .catch((err) => {})
  },

  fetchMonthlyInfluence: ({ commit }, year) => {
    axios
      .get(
        `${process.env.VUE_APP_BASE_URL}/v2/calendar/monthly-influence?year=${year}`
      )
      .then((res) => {
        // console.log(res.data)
        const dateFormatter = new Intl.DateTimeFormat('en-US', {
          day: 'numeric',
          month: 'short',
        })
        let monthArray = res.data.map((r) => {
          return {
            ...r.month,
            date: dateFormatter.format(new Date(r.date)),
          }
        })

        monthArray = monthArray.map((r) => {
          return {
            ...r,
            god: r.heavenly_stem.ten_god,
            animal: {
              mandarin: r.earthly_branch.mandarin,
              name: r.earthly_branch.name_en,
              name_th: r.earthly_branch.name_th,
              pinyin: r.earthly_branch.pinyin,
            },
          }
        })
        monthArray = [null, ...monthArray]
        commit('setMonthlyInfluence', monthArray)
      })
      .catch((err) => {})
    // Promise.all(promises).then(() => {
    // 	monthArray = monthArray.map((month) => {
    // 		return (month = month.month);
    // 	});
    // 	// commit("setMonthlyInfluence", monthArray);
    // });
  },

  getFiveStructure: ({ commit, dispatch }, request) => {
    request.time = request.time === '' ? 'null' : request.time
    let date = request.date
    let params = {
      date: date,
      // time: request.time,
    }
    if (request.time !== 'null') {
      params.time = request.time
    }
    axios
      .get(`/bazis/${request.date}/five-structure`, { params: params })
      .then((res) => {
        let elements = res.data
        let { metal, water, wood, fire, earth } = elements
        commit('setFiveStructure', [metal, water, wood, fire, earth])
      })
  },

  getAnnualBazi: ({ commit, dispatch }, natal) => {
    let getYearBranch1 = getYearBranch(natal)
    let getMonthBranch1 = getMonthBranch(natal)
    let getDayMonthAuxilaryStar1 = getDayMonthAuxilaryStar(natal)
    let getDayStem1 = getDayStem(natal)
    let getDayBranch1 = getDayBranch(natal)
    let merge = deepmerge.all([
      getYearBranch1,
      getMonthBranch1,
      getDayMonthAuxilaryStar1,
      getDayStem1,
      getDayBranch1,
    ])
    commit('setAnnualBazi', merge)
  },

  getMyDestiny: ({ commit, dispatch }, natal) => {
    let getYearBranchDestiny1 = getYearBranchDestiny(natal)
    let getMonthBranchDestiny1 = getMonthBranchDestiny(natal)
    let getDayMonthAuxilaryStarDestiny1 = getDayMonthAuxilaryStarDestiny(natal)
    let getDayStemDestiny1 = getDayStemDestiny(natal)
    let getDayBranchDestiny1 = getDayBranchDestiny(natal)
    let merge = deepmerge.all([
      getYearBranchDestiny1,
      getMonthBranchDestiny1,
      getDayMonthAuxilaryStarDestiny1,
      getDayStemDestiny1,
      getDayBranchDestiny1,
    ])
    commit('setMyDestiny', merge)
  },

  // getTenGod: ({ commit }, natal) => {
  //     let godCount = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  //     // Count each god in natal chart
  //     if (natal.hour !== null) {
  //         godCount[natal.hour?.god.id]++;
  //     }
  //     godCount[natal.month.god.id]++;
  //     godCount[natal.year.god.id]++;
  //     if (natal.hour !== null) {
  //         natal.hour?.hidden_stems.forEach((hour) => {
  //             godCount[hour.ten_god.id]++;
  //         });
  //     }
  //     natal.day.hidden_stems.forEach((day) => {
  //         godCount[day.ten_god.id]++;
  //     });

  //     natal.month.hidden_stems.forEach((month) => {
  //         godCount[month.ten_god.id]++;
  //     });

  //     natal.year.hidden_stems.forEach((year) => {
  //         godCount[year.ten_god.id]++;
  //     });

  //     // remove first element (unused)
  //     godCount.shift();
  //     godCount = godCount.map((element, index) => {
  //         return {
  //             value: parseFloat((element / Math.max(...godCount)).toFixed(3)),
  //             data: godData[index],
  //         };
  //     });
  //     commit('setTenGod', godCount);
  // },
}

function cleanParams(params) {
  return Object.fromEntries(
    Object.entries(params).filter(
      ([_, v]) => v !== null && v !== undefined && v !== ''
    )
  )
}

export default {
  state,
  mutations,
  actions,
  getters,
}
